import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import { addFileMetaDataValue, fileMetaDataCategoryFetchData}  from '../../actions/fileData';
import { Button, Form, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle } from 'reactstrap';
import Loader from '../../components/Loader';
class fileMetaDataValueValueForm extends Component {  

    constructor(props,context) {
        super(props,context);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {postData: false, edit: false, 'fileMetaDataValue': false}
    }



    
    componentWillMount()
    {

        if(this.props.clientPath.clientPath) {
            this.props.fileMetaDataCategoryFetchData(this.props.clientPath.clientPath)
        }

        if(this.props.match.params.categoryid && this.props.fileMetaDataCategory)
        {
            const categoryId = this.props.match.params.categoryid;
            const category = this.props.fileMetaDataValue.data.find(e => e.id === categoryId);
            
            this.setState({'edit': true, 'postData': category, 'fileMetaDataValue': category})
            
        }
    }

    handleSubmit(e) {
        e.preventDefault();       

        this.props.addFileMetaDataValue(
            this.props.clientPath.clientPath, 
            this.state.postData,
        );
    }

    setInputState(e) {              
      this.setState({
          postData: {...this.state.postData, [e.target.name]: e.target.value }

      });   
    }

    setCheckedValue(e) {
        this.setState({
            postData: {...this.state.postData, [e.target.name]: e.target.checked ? 1 : 0 }
        })
    }



    render() {    
    
        return (
            <div className="animated fadeIn">  
             {this.props.fileMetaDataCategory.data ?
             <Card>
                <CardBody>
                    <CardTitle><i className="fa fa-file"></i> Metadata waarde {this.state.edit ? 'bewerken' : 'toevoegen'}</CardTitle>   
                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                        <FormGroup>
                            <Label for="name">Metadata waarde</Label>
                            <Input type="text" defaultValue={this.state.fileMetaDataValue ? this.state.fileMetaDataValue.name : ''} onChange={(e) => this.setInputState(e)} name="name" id="name" placeholder="Metadata waarde" />
                        </FormGroup>
                        <FormGroup>
                            <Label for="category_id">Metadata categorie</Label>
                            <Input type="select" name="category_id" value={this.state.postData ? this.state.postData.category_id : ''} onChange={(e) => this.setInputState(e)} id="category_id">
                            <option value="NULL">Selecteer een metadata categorie</option>
                             {this.props.fileMetaDataCategory.data ? this.props.fileMetaDataCategory.data.map(val => {                                     
                                if(val.is_text === '0') { return (<option  key={val.id} value={val.id}>{val.name}</option>)}
                            }) : null}
                            </Input>                                   
                        </FormGroup> 
                        <FormGroup check>
                            <Label check for="is_notifier">
                                <Input type="checkbox" defaultChecked={this.state.fileMetaDataValue && this.state.fileMetaDataValue.is_notifier === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_notifier" id="is_notifier" />
                                Is urgente melding?
                            </Label>
                        </FormGroup>   
                         <FormGroup check>
                            <Label check for="is_active">
                                <Input type="checkbox" defaultChecked={this.state.fileMetaDataValue && this.state.fileMetaDataValue.is_active === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_active" id="is_active" />
                                Is actief?
                            </Label>
                        </FormGroup>   
                       
                        <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-dot-circle-o"></i> {this.state.edit ? 'Bijwerken' : 'Toevoegen'}</button>
                    </Form>
                </CardBody>
            </Card>
            : <Loader />}
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        fileMetaDataCategory: state.FileMetaDataCategoryReducer,  
        fileMetaDataValue: state.FileMetaDataValueReducer, 
        clientPath: state.clientPathReducer         
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFileMetaDataValue: (url, postData) => dispatch(addFileMetaDataValue(url, postData)),
        fileMetaDataCategoryFetchData: (url) => dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories')),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(fileMetaDataValueValueForm))



// WEBPACK FOOTER //
// ./src/views/Filemetadatavalue/form.js